import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck, AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function LinkCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loading, user, setUser } = useAuth();
  const [error, setError] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (loading || done.current) return;
    done.current = true;
    const code = params.get("code");
    const state = params.get("state");
    if (!user) {
      setError("Sign in with your One Talanta ID first, then link again.");
      return;
    }
    if (!code || !state) {
      setError("Missing authorization details from Talanta Sport.");
      return;
    }
    api
      .post("/sport/link/complete", { code, state })
      .then(({ data }) => {
        setUser(data);
        toast.success(`Linked Talanta Sport athlete ${data.linked_athlete?.name}`);
        navigate("/?linked=1", { replace: true });
      })
      .catch((e) => setError(e?.response?.data?.detail || "Linking failed"));
  }, [loading, user, params, navigate, setUser]);

  return (
    <div className="min-h-screen bg-talanta-green text-white flex items-center justify-center px-6">
      <div data-testid="link-callback-page" className="max-w-sm w-full text-center">
        {error ? (
          <>
            <AlertTriangle className="h-10 w-10 text-talanta-red mx-auto" />
            <p data-testid="link-callback-error" className="mt-4 font-display font-semibold">{error}</p>
            <button onClick={() => navigate("/")} className="mt-5 rounded-full bg-talanta-red px-6 py-2.5 text-sm font-semibold">Back home</button>
          </>
        ) : (
          <>
            <Loader2 className="h-10 w-10 animate-spin mx-auto text-talanta-gold" />
            <p className="mt-4 font-display font-semibold flex items-center justify-center gap-2"><ShieldCheck className="h-4 w-4" /> Linking your Talanta Sport account…</p>
          </>
        )}
      </div>
    </div>
  );
}
